import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Inline, Box, Badge } from "braid-design-system";
import { translations } from "../../../.vocab/index.mjs";
import { badge } from "./JobBadges.css.mjs";
const premiumAdBadgeAutomation = "premiumAdBadge";
const JobBadge = ({ label, tone, automation }) => /* @__PURE__ */ jsx(Box, { className: badge, children: /* @__PURE__ */ jsx(Badge, { tone, bleedY: true, data: { automation }, children: label }) });
const useJobBadges = ({
  tags,
  isPremium
}) => {
  const { t } = useTranslations(translations);
  const badges = isPremium ? [
    {
      label: t("Featured"),
      tone: "promote",
      automation: premiumAdBadgeAutomation
    }
  ] : [];
  const tagsBadges = (tags == null ? void 0 : tags.reduce((allBadges, { type, label }) => {
    if (type === "URGENT") {
      allBadges.push({ label, tone: "promote", automation: "urgentAdBadge" });
    }
    return allBadges;
  }, [])) ?? [];
  return badges.concat(tagsBadges);
};
const JobBadges = ({
  tags,
  isPremium
}) => {
  const badges = useJobBadges({ tags, isPremium });
  return badges.length ? /* @__PURE__ */ jsx(Inline, { space: "xsmall", children: badges.map(({ automation, label, tone }, index) => /* @__PURE__ */ jsx(
    JobBadge,
    {
      label,
      tone,
      automation
    },
    index
  )) }) : null;
};
export {
  JobBadges,
  premiumAdBadgeAutomation
};
